import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getDjangoEndpoint } from "src/utils/apiEndpoints";
import axiosInstance from "src/store/features/auth/axiosCSRF";
export interface iGetKinaseSequenceState {
    response: any;
    message: string;
    isLoading: boolean;
    error: string | null;
}

const initialState: iGetKinaseSequenceState = {
    response: [],
    message: "",
    isLoading: false,
    error: null
}


export const getKinaseSequenceAPI = createAsyncThunk(
    "GET_KINASE_SEQUENCE",
    async(params: {entryname: string}, {rejectWithValue}) => {
        try {
            const djangoEndpoint = getDjangoEndpoint();
            
            const pathParam = `/data/kinase-inhibitor/off-target-seq/?kinase_name=${encodeURIComponent(params.entryname)}`;
            const response = await axiosInstance.get(`${djangoEndpoint}${pathParam}`, {
                withCredentials: true,
            });
            
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response ? error.response.data : error.message);
        }
    }
);

export const kinaseSequenceSlice = createSlice({
    name: "getKinaseSequenceList",
    initialState,
    reducers: {
        // Add a reset action to clear the state when needed
        resetSequenceData: (state) => {
            state.response = [];
            state.message = "";
            state.error = null;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getKinaseSequenceAPI.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(getKinaseSequenceAPI.fulfilled, (state, action) => {
                state.isLoading = false;
                state.response = action.payload; // Store the response data
                state.message = "success";
            })
            .addCase(getKinaseSequenceAPI.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload as string || "An error occurred";
                state.message = "error";
            });
    }
});

export const { resetSequenceData } = kinaseSequenceSlice.actions;
export default kinaseSequenceSlice.reducer;